import { IconButton } from '@material-ui/core';
import { FileCopyRounded } from '@material-ui/icons';
import { useObserver } from 'mobx-react-lite';
import React, { ReactElement, useContext, useState } from 'react';
import { EmailShareButton, EmailIcon, FacebookShareButton, FacebookIcon, InstapaperShareButton, InstapaperIcon, LinkedinShareButton, LinkedinIcon, PinterestShareButton, PinterestIcon, RedditShareButton, RedditIcon, TumblrShareButton, TumblrIcon, TwitterShareButton, TwitterIcon, WhatsappShareButton, WhatsappIcon } from 'react-share';
import { AppContext } from '../../../state/app.state';
import Modal from '../Modal/Modal';
import './ShareModal.scss';

type ShareModalProps={
    className?: string;
    id?: string;
};

const ShareModal: React.FC<ShareModalProps> = ({ children, className, id }): ReactElement => {
    const { state, presentationState } = useContext(AppContext);
    const quote = `Kolla in ${state?.project?.name}`;
    const [copied, setCopied] = useState(false);

    return useObserver(() => (
        <Modal showModal={!!state?.shareLink && !!presentationState?.showShareModal}
            className='bv-share-modal'
            modalPaperStyle={{
                maxHeight: '100%',
                margin: 0,
                width: presentationState?.modalWidth || '80vw',
                borderRadius: '2rem',
                overflow:'hidden' }}
            onBackdropClick={(): void => {
                state && state.setShareLink(undefined);
                setCopied(false);
                presentationState?.setShowShareModal(false);
            }}>
            {state?.shareLink && <div className='bv-share-content'>
                <div className='bv-share-content-upper'>
                    <div className='bv-share-content-upper-top'>
                        <p style={{ fontSize: '2rem', marginBottom: '1rem' }}>{state.shareLink.shareModalText || `Dela ${state.project?.name || ''}!` }</p>
                    </div>
                    <div className='bv-share-content-upper-bottom'>
                        {copied && <p className='bv-share-content-text bv-share-content-text-green'>Länken är kopierad!</p>}
                        <IconButton className='bv-share-content-icon' onClick={(): void => {
                            navigator.clipboard.writeText(state.shareLink?.value || '');
                            setCopied(true);
                        }}><FileCopyRounded ></FileCopyRounded></IconButton>
                        <p className='bv-share-content-text'>{state.shareLink?.value}</p>
                    </div>
                </div>
                <div className='bv-share-content-lower'>
                    <EmailShareButton url={state.shareLink.value} children={<EmailIcon/>}/>
                    <FacebookShareButton url={state.shareLink.value.toString()} quote={quote} children={<FacebookIcon/>}/>
                    <TwitterShareButton url={state.shareLink.value} children={<TwitterIcon/>}/>
                    <WhatsappShareButton url={state.shareLink.value} children={<WhatsappIcon/>}/>
                    <LinkedinShareButton url={state.shareLink.value} children={<LinkedinIcon/>}/>
                </div>
            </div>}
        </Modal>
    ));
};


export default ShareModal;